import Vue from 'vue';
import Router from 'vue-router';
import Register from './views/Register.vue';
import Cart from './views/Cart.vue';
import NotFound from './views/NotFound.vue';
import BalanceDueEvents from './views/BalanceDueEvents.vue';
import UpcomingEvents from './views/UpcomingEvents.vue';
import Events from './views/Events.vue';
import Registrants from './views/Registrants.vue';
import Confirmation from './views/Confirmation.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/balance-due-registrations',
      name: 'balance-due-registrations',
      component: BalanceDueEvents,
    },
    {
      path: '/upcoming-events',
      name: 'upcoming-events',
      component: UpcomingEvents,
    },
    {
      path: '/registrants',
      name: 'registrants',
      component: Registrants,
    },
    {
      path: '/register/events',
      name: 'events',
      component: Events,
    },
    {
      path: '/register/event/:eventID/:hiddenCode?',
      name: 'register',
      component: Register,
    },
    {
      path: '/cart',
      name: 'cart',
      component: Cart,
    },
    {
      path: '/confirmation/:uuid',
      name: 'confirmation',
      component: Confirmation,
    },
    {
      path: '/not-found',
      name: 'not-found',
      component: NotFound,
    },
    // always redirect to not found
    {
      path: '*',
      redirect: '/not-found',
    },
  ],
});
